export class PartValidator {
  static validate(partData: any, t: any): string[] {
    const validationErrors: string[] = [];

    if (!partData.label?.trim()) {
      validationErrors.push(t("piece:label"));
    }

    // ref n'est plus obligatoire
    // if (!partData.ref?.trim()) {
    //   validationErrors.push(t("piece:ref"));
    // }

    if (!partData.price) {
      validationErrors.push(t("piece:price"));
    }

    if (!partData.unity?.trim()) {
      validationErrors.push(t("piece:unity"));
    }

    return validationErrors;
  }
}
